/**
 * Resolve product id from router location.
 * Prefer URL query so refresh / shareable links keep working;
 * fall back to history state used by older navigations.
 */
import { getBuyNowDisplayPrice } from "./listingPrice";

export function getProductCodeFromLocation(location) {
  const params = new URLSearchParams(location?.search || "");
  const fromQuery = params.get("id") || params.get("product_code");
  if (fromQuery != null && fromQuery !== "") return fromQuery;
  const fromState = location?.state?.product_code;
  if (fromState != null && fromState !== "") return fromState;
  return null;
}

export function getListingPreviewFromLocation(location) {
  return (
    location?.state?.listingPreview ||
    location?.state?.bidPreview ||
    null
  );
}

/** Snapshot of list-row fields shown when product_detail is unavailable */
export function buildListingPreview(item) {
  if (!item || typeof item !== "object") return null;
  return {
    product_id:
      item.product_id ?? item.productId ?? item.id ?? item.p_id ?? null,
    product_name: item.product_name ?? item.vehicle ?? item.name ?? null,
    registration:
      item.registration ??
      item.Registration ??
      item.reg ??
      item.registration_number ??
      null,
    product_price:
      getBuyNowDisplayPrice(item, { buyNowFloor: true }) ??
      item.product_price ??
      item.price ??
      item.start_price ??
      null,
    buy_now_price: item.buy_now_price ?? null,
    buy_now: item.buy_now ?? null,
    product_description: item.product_description ?? item.description ?? null,
    product_category: item.product_category ?? item.category ?? null,
    product_image: item.product_image ?? item.image ?? null,
    status: item.status ?? item.auction_status ?? null,
  };
}

export function buildProductLocation(pathname, productId, extraState = {}) {
  const id = String(productId);
  return {
    pathname,
    search: `?id=${encodeURIComponent(id)}`,
    state: {
      product_code: id,
      ...extraState,
    },
  };
}
